import React, { useEffect, useState } from 'react'
import Modal from 'react-modal';
import { getDestinataireInfo, updateSenderCommande } from '../../api/commande'
import toast from 'react-hot-toast'
import { useForm, Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import PhoneInput from 'react-phone-input-2';
import { CustomInput } from '../../Containers/RegisterTransporter/style';
import { useTranslation } from 'react-i18next';

function UpdateInfoDestinataireModal({ modalIsOpenUpdate, setModalIsOpenUpdate, commandeId }) {
    const { register, handleSubmit, setValue, watch, reset, control, formState: { errors } } = useForm();
    const [chargementEnCours, setChargementEnCours] = useState(false)
    const [submitLoading, setSubmitLoading] = useState(false)
    const [destinataires, setDestinataires] = useState([])
    const token = useSelector(state => state.auth.token);
    const {t} = useTranslation();
    const fetchData = async (commandeId) => {
        setChargementEnCours(true)
        try {
            const res = await getDestinataireInfo(commandeId, token)
            console.log('res', res)
            
            if (res?.data?.destinataires) {
                setDestinataires(res.data.destinataires)
                
                // Pré-remplir les valeurs pour chaque destinataire
                res.data.destinataires.forEach((dest, index) => {
                    setValue(`nom_signataire_${index}`, dest.destinataire.lastNameDistinator)
                    setValue(`prénom_signataire_${index}`, dest.destinataire.firstNameDistinator)
                    setValue(`téléphone1_signataire_${index}`, dest.destinataire.phone1Distinator)
                    setValue(`téléphone2_signataire_${index}`, dest.destinataire.phone2Distinator)
                    setValue(`email_signataire_${index}`, dest.destinataire.emailDistinator || '')
                })
            }
        } catch (error) {
            toast.error("Une erreur s'est produite lors du chargement", {
                style: {
                    fontFamily: 'Montserrat',
                },
            });
        } finally {
            setChargementEnCours(false)
        }
    }

    useEffect(() => {
        if (commandeId && modalIsOpenUpdate) {
            fetchData(commandeId)
        }
    }, [commandeId, modalIsOpenUpdate]);

    const onSubmit = async (data) => {
        setSubmitLoading(true)
        try {
            console.log('Données soumises:', data)
            
            // Transformer les données en tableau pour le backend
            const destinatairesData = destinataires.map((dest, index) => ({
                courseId: dest.courseId,
                index: index,
                nom_signataire: data[`nom_signataire_${index}`],
                prénom_signataire: data[`prénom_signataire_${index}`],
                téléphone1_signataire: data[`téléphone1_signataire_${index}`],
                téléphone2_signataire: data[`téléphone2_signataire_${index}`],
                email_signataire: data[`email_signataire_${index}`] || ''
            }))
            
            console.log('Données formatées:', destinatairesData)
            
            // Appel API pour mettre à jour
            await updateSenderCommande(destinatairesData, token, commandeId)
            
            toast.success('Informations mises à jour avec succès', {
                style: {
                    fontFamily: 'Montserrat',
                },
            })
            
            // Fermer le modal après succès
            reset()
            setModalIsOpenUpdate(false)
            
        } catch (error) {
            console.error('Erreur lors de la mise à jour:', error)
            toast.error(
                error?.response?.data?.message || "Erreur lors de la mise à jour",
                {
                    style: {
                        fontFamily: 'Montserrat',
                    },
                }
            )
        } finally {
            setSubmitLoading(false)
        }
    }

    return (
        <Modal
            isOpen={modalIsOpenUpdate}
            onRequestClose={() => {
                reset()
                setModalIsOpenUpdate(false)
            }}
            style={{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.45)',
                    zIndex: 9999,
                },
                content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    transform: 'translate(-50%, -50%)',
                    borderRadius: 19,
                    background: '#fff',
                    padding: '2rem',
                    maxHeight: '80vh',
                    overflowY: 'auto',
                    minWidth: '600px'
                },
            }}
            contentLabel='Modifier les informations du destinataire'
        >
            <div
                style={{
                    width: '100%',
                    fontFamily: 'Montserrat',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 15,
                    textAlign: 'left',
                    color: '#838EAB',
                }}
            >
                <div
                    style={{
                        color: '#51C7F2',
                        fontSize: 25,
                        marginBottom: '1rem',
                        fontWeight: 'bold',
                        fontFamily: 'Montserrat'
                    }}
                >
                   {t("editRecipientInformation")}
                </div>

                {chargementEnCours ? (
                    <div style={{ padding: '2rem', textAlign: 'center' }}>
                        <div className='loader'></div>
                        <p> {t("Loading")}</p>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
                        {destinataires.map((dest, index) => (
                            <div key={dest.courseId} style={{ marginBottom: '2rem', padding: '1rem', background: '#f8f9fa', borderRadius: '8px' }}>
                                {/* Titre de la course avec index */}
                                <div
                                    style={{
                                        color: '#51C7F2',
                                        fontSize: 18,
                                        fontWeight: 'bold',
                                        marginBottom: '1rem',
                                    }}
                                >
                                    {t("trip")} {index + 1}
                                </div>
                                
                                {/* Adresse de destination */}
                                <div
                                    style={{
                                        color: '#838EAB',
                                        fontSize: 14,
                                        marginBottom: '1.5rem',
                                        padding: '0.5rem',
                                        background: '#e9ecef',
                                        borderRadius: '5px',
                                    }}
                                >
                                    <strong>{t("destinationAddress:")} :</strong> {dest.adresse_destination}
                                </div>

                                {/* Nom et Prénom */}
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: 'row',
                                        gap: '1rem',
                                        marginBottom: '1rem',
                                    }}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            width: '50%',
                                        }}
                                    >
                                        <span style={{ marginBottom: '.5rem', color: 'black', fontSize: 14 }}>
                                         {t("last_name")}                                      
                                        </span>
                                        <CustomInput
                                            type="text"
                                            {...register(`nom_signataire_${index}`, { required: t("nom_destinataire_err") })}
                                            style={{
                                                width: '100%',
                                                padding: '0.75rem',
                                                borderRadius: '8px',
                                                border: '1px solid #ddd',
                                                fontSize: '14px',
                                                outline: 'none',
                                            }}
                                        />
                                        {errors[`nom_signataire_${index}`] &&
                                            <span style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
                                                {errors[`nom_signataire_${index}`].message}
                                            </span>
                                        }
                                    </div>

                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            width: '50%',
                                        }}
                                    >
                                        <span
                                            style={{
                                                marginBottom: '.5rem',
                                                color: 'black',
                                                fontSize: 14,
                                            }}
                                        >
                                    {t("first_name")}
                                        </span>
                                        <CustomInput
                                            type="text"
                                            {...register(`prénom_signataire_${index}`,  { required: t("prenom_destinataire_err") })}
                                            style={{
                                                width: '100%',
                                                padding: '0.75rem',
                                                borderRadius: '8px',
                                                border: '1px solid #ddd',
                                                fontSize: '14px',
                                                outline: 'none',
                                            }}
                                        />
                                        {errors[`prénom_signataire_${index}`] &&
                                            <span style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
                                                {errors[`prénom_signataire_${index}`].message}
                                            </span>
                                        }
                                    </div>
                                </div>

                                {/* Téléphones */}
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: 'row',
                                        gap: '1rem',
                                        marginTop: '1rem'
                                    }}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            width: '50%',
                                        }}
                                    >
                                        <span
                                            style={{
                                                marginBottom: '.5rem',
                                                color: 'black',
                                                fontSize: 14,
                                            }}
                                        >
                                            {t("contact_us_formulair_item2")} 1
                                        </span>
                                                 <PhoneInput
                                {...register(`téléphone1_signataire_${index}`, 
                                { required: t("phone_number_err1") })}
                                value={watch(`téléphone2_signataire_${index}`)}
                                onChange={(newPhoneValue) =>setValue(`téléphone1_signataire_${index}`,newPhoneValue)}
                                country='fr'
                                inputStyle={{
                                    paddingRight: '1.5rem',
                                    paddingTop: '1.5rem',
                                    paddingBottom: '1.5rem',
                                    borderRadius: '0.5rem',
                                    fontFamily: 'Montserrat',
                                    color: '#858ea8',
                                    flex: '1',
                                    display: 'flex',
                                    width: '100%',
                                    border: '1px solid #ddd',

                                }}
                                buttonStyle={{
                                    borderRadius: '0.5rem',
                                    fontFamily: 'Montserrat',
                                    color: '#858ea8',
                                    flex: '1',
                                    display: 'flex',
                                    border: '1px solid #ddd',

                                }}
                            />
                                        {errors[`téléphone1_signataire_${index}`] &&
                                            <span style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
                                                {errors[`téléphone1_signataire_${index}`].message}
                                            </span>
                                        }
                                    </div>

                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            width: '50%',
                                        }}
                                    >
                                        <span
                                            style={{
                                                marginBottom: '.5rem',
                                                color: 'black',
                                                fontSize: 14,
                                            }}
                                        >
                                           {t("contact_us_formulair_item2")} 2
                                        </span>
                                          <PhoneInput
                                {...register(`téléphone2_signataire_${index}`, 
                                { required: t("phone_number_err1") })}
                                value={watch(`téléphone2_signataire_${index}`)}
                                onChange={(newPhoneValue) =>setValue(`téléphone2_signataire_${index}`,newPhoneValue)}
                                country='fr'
                                inputStyle={{
                                    paddingRight: '1.5rem',
                                    paddingTop: '1.5rem',
                                    paddingBottom: '1.5rem',
                                    borderRadius: '0.5rem',
                                    fontFamily: 'Montserrat',
                                    color: '#858ea8',
                                    flex: '1',
                                    display: 'flex',
                                    width: '100%',
                                    border: '1px solid #ddd',

                                }}
                                buttonStyle={{
                                    borderRadius: '0.5rem',
                                    fontFamily: 'Montserrat',
                                    color: '#858ea8',
                                    flex: '1',
                                    display: 'flex',
                                    border: '1px solid #ddd',

                                }}
                            />
                                
                                        {errors[`téléphone2_signataire_${index}`] &&
                                            <span style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
                                                {errors[`téléphone2_signataire_${index}`].message}
                                            </span>
                                        }
                                    </div>
                                </div>

                                {/* Email */}
                                <div
                                    style={{
                                        width: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        marginTop: '1rem'
                                    }}
                                >
                                    <span
                                        style={{
                                            marginBottom: '.5rem',
                                            color: 'black',
                                            fontSize: 14,
                                        }}
                                    >
                                       {t("email")}
                                    </span>
                                    <CustomInput
                                        type='text'
                                        {...register(`email_signataire_${index}`, {
                                            required: t("email_destinataire_err"),
                                            pattern: {
												value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
												message: t("email_err_message"),
											},
                                        })}
                                        style={{
                                            width: '100%',
                                            padding: '0.75rem',
                                            borderRadius: '8px',
                                            border: '1px solid #ddd',
                                            fontSize: '14px',
                                            outline: 'none',
                                        }}
                                    />
                                    {errors[`email_signataire_${index}`] &&
                                        <span style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
                                            {errors[`email_signataire_${index}`].message}
                                        </span>
                                    }
                                </div>
                            </div>
                        ))}

                        {/* Boutons */}
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '1rem',
                                gap: '1rem',
                            }}
                        >
                            <button
                                type='submit'
                                disabled={submitLoading}
                                style={{
                                    background: submitLoading ? '#ccc' : '#5BBCEA',
                                    border: 'none',
                                    cursor: submitLoading ? 'not-allowed' : 'pointer',
                                    color: 'white',
                                    fontFamily: 'Montserrat',
                                    padding: '1rem 2rem',
                                    borderRadius: 6,
                                    fontWeight: 'bold',
                                    height: '50px',
                                    minWidth: "120px",
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                {submitLoading ? <div className='loader'></div> : t("edit")}

                            </button>
                            <button
                                type='button'
                                onClick={() => {
                                    reset()
                                    setModalIsOpenUpdate(false)
                                }}
                                disabled={submitLoading}
                                style={{
                                    background: 'red',
                                    border: 'none',
                                    cursor: submitLoading ? 'not-allowed' : 'pointer',
                                    color: 'white',
                                    fontFamily: 'Montserrat',
                                    padding: '1rem 2rem',
                                    borderRadius: 6,
                                    fontWeight: 'bold',
                                    height: '50px',
                                    minWidth: "120px"
                                }}
                            >
                           {t("cancel")}
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </Modal>
    )
}

export default UpdateInfoDestinataireModal